import React from 'react';
import { ENTITY_TYPES } from '@adsk/bim360-matrix-react-entity-linker';
import getParsedAssetsWithStatuses from './helpers/getParsedAssetsWithStatuses';
import getStatusesUniqueIds from './helpers/getStatusesUniqueIds';
import createQueryString from './helpers/createQueryString';
import formatAssetName from './helpers/formatAssetName';
import getEnvConfig from './helpers/getEnvConfig';
import AssetEntityBlock from './AssetEntityBlock';
import AssetEntityPickerItem from './AssetEntityPickerItem';
import AssetLinkedEntitiesCellItem from './AssetLinkedEntitiesCellItem';
import AssetsPickerSearchBox from './AssetsPickerSearchBox';
import { CONFIG_KEYS } from './consts';
import api from './api';

export default {
  entityType: ENTITY_TYPES.ASSET,
  metadata: {},
  createPlugin: ({ env, region, projectId, getToken }) => {
    const baseUrl = getEnvConfig(env, region, CONFIG_KEYS.ASSETS_BE);
    const EntityBlock = props => (
      <AssetEntityBlock {...props} env={env} region={region} projectId={projectId} />
    );

    return {
      queryEntities: async query => {
        const token = await getToken();
        const { results: assets, pagination } = await api.queryAssets(
          baseUrl,
          projectId,
          token,
          query.nextUrl,
          createQueryString(query)
        );
        const statusesUniqueIds = getStatusesUniqueIds(assets);
        const { results: statuses } = await api.batchGetStatuses(
          baseUrl,
          projectId,
          token,
          statusesUniqueIds
        );

        const nextPageQuery = pagination &&
          pagination.nextUrl && { ...query, nextUrl: pagination.nextUrl };

        return {
          data: getParsedAssetsWithStatuses(assets, statuses),
          nextPageQuery
        };
      },
      getEntitiesByIds: async ids => {
        const token = await getToken();
        const { results: assets } = await api.batchGetAssets(baseUrl, projectId, token, ids);
        const statusesUniqueIds = getStatusesUniqueIds(assets);
        const { results: statuses } = await api.batchGetStatuses(
          baseUrl,
          projectId,
          token,
          statusesUniqueIds
        );

        return {
          data: getParsedAssetsWithStatuses(assets, statuses)
        };
      },
      EntityBlock,
      EntityPickerItem: AssetEntityPickerItem,
      formatEntityDisplayText: formatAssetName,
      LinkedEntitiesCellItem: AssetLinkedEntitiesCellItem,
      CustomPickerSearchBox: AssetsPickerSearchBox
    };
  }
};
